import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../i18n";

export const FloatingCTA = ({ t }) => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-cta"
      aria-label={t.hero.cta}
      className="group fixed bottom-5 left-5 z-50 flex items-center gap-3 bg-green-600 px-5 py-4 text-sm font-semibold text-white shadow-2xl transition-all duration-200 hover:bg-green-700 hover:shadow-[0_20px_60px_-15px_rgba(22,163,74,0.6)] sm:bottom-6 sm:left-6"
    >
      <span className="relative flex h-5 w-5 items-center justify-center">
        <span className="absolute inset-0 animate-ping rounded-full bg-white/40" />
        <MessageCircle size={20} className="relative" />
      </span>
      <span className="hidden sm:inline">{t.hero.cta}</span>
    </a>
  );
};
